import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorCheckService {
  
  public isErrorUnauthorised = (error: Error) => {
    return error && (error instanceof HttpErrorResponse) && error.status == 403;
  }
}
